import { notify } from "../../event-bus";
import Vue from "vue";

export default {
  namespaced: true,
  state: {
    calledCard: "",
    callSection: "card",
    points: 60,
    suit: "",
    calledPoints: 60,
    winnerUser: {},
  },
  getters: {
    calledCard: (state) => {
      return state.calledCard;
    },
    callSection: (state) => {
      return state.callSection;
    },
    playerWinner: (state) => {
      return state.playerWinner;
    },
    points: (state) => {
      return state.points;
    },
    suit: (state) => {
      return state.suit;
    },
    calledPoints: (state) => {
      return state.calledPoints;
    },
    winnerUser: (state) => {
      return state.winnerUser;
    },
  },

  actions: {
    callCard({ commit }, payload) {
      return Vue.http
        .post(
          `${process.env.VUE_APP_BACKEND_APP}/api/games/${this.state.game.game.id}/users/${this.state.user.user.id}/call`,
          payload,
          {
            headers: {
              "Content-Type": "application/json",
              Accept: "application/json",
              "X-Socket-Id": window.Echo.socketId(),
            },
          }
        )
        .then((response) => {
          const users = Object.entries(
            response.data.game.data.users
          ).map(([key, value]) => ({ key, value }));
          const nextUser = users.find((user) => {
            return user.value.is_user_turn;
          });
          payload['userId'] = this.state.user.user.id;
          commit("game/updateUserTurn", nextUser.value.id, { root: true });
        })
        .catch((error) => {
          notify(error, "ERROR");
        });
    },
    callSuit({ commit }, payload) {
      const payloadNew = {
        card: payload.card,
      };
      return Vue.http
        .post(
          `${process.env.VUE_APP_BACKEND_APP}/api/games/${this.state.game.game.id}/users/${this.state.user.user.id}/callsuit`,
          payloadNew,
          {
            headers: {
              "Content-Type": "application/json",
              Accept: "application/json",
            },
          }
        )
        .then(() => {
          commit("updateSuit", "finished");
        })
        .catch((error) => {
          notify(error, "ERROR");
        });
    },
  },
  mutations: {
    updateCall(state, callData) {
      state.calledPoints = (isNaN(callData.points)) ? 60 : Number(callData.points);
      if (state.calledPoints >= state.points) {
        state.points = state.calledPoints + 2;
      }
      if (callData.card != "pass") {
        state.calledCard = callData.card;
      }
      this.state.game.players.map((player) =>
        player.id == callData.userId
          ? (player.called_card = callData.card)
          : player
      );
      this.state.game.players.map((player) =>
        player.id == callData.userId
          ? (player.called_points = callData.points)
          : player
      );
      if (state.calledCard == 2) {
        state.callSection = "points";
      }
    },
    updateCallSection(state, payload) {
      if (payload.userId == this.state.game.players[0].id) {
        state.callSection = "suit";
      } else {
        state.callSection = "finished";
      }
      state.calledCard = payload.card;
      state.winnerUser = this.state.game.players.find(
        (player) => player.id == payload.userId
      );
      state.points = payload.points;
    },
    updateSuit(state, section) {
      state.callSection = section;
    },
    winningUpdate(state, payload) {
      state.callSection = "finished";
      state.calledCard = payload.card;
      state.calledPoints = payload.points;
    },
    updatePoints(state, points) {
      state.points = points;
    },
    resetCall(state) {
      state.calledCard = ""
      state.callSection = "card"
      state.points = 60
      state.suit = ""
      state.calledPoints = 60
      state.winnerUser = {}
    }
  }
};
